import React from "react"
import { Tabs, Tab } from "material-ui/Tabs"
import strings from "../../localization/strings"
import PayGroups from "./PayGroups"
import PayTypes from "./PayTypes"
import OTPolicies from "./OTPolicies"
import AccountStore from "../../stores/AccountStore"
import AuthenticationStore from "../../stores/AuthenticationStore"
import autobind from "class-autobind"
import Accruals from "./Accruals"
import HolidayTemplates from "./HolidayTemplates"
import * as permissionHelper from "../../helpers/permissionHelper"
import * as accountActions from "../../actions/AccountActions"
import { IPayType, IPayGroup, IAccrual, IHolidayTemplate, IOTPolicy } from "../../models"
interface IProps {

}
interface IState {
	payTypes: IPayType[]
	payGroups: IPayGroup[]
	otPolicies: IOTPolicy[]
	accruals: IAccrual[]
	holidayTemplates: IHolidayTemplate[]
	enablePayroll: boolean
}

export default class PayConfiguration extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			payTypes: [],
			payGroups: [],
			otPolicies: [],
			accruals: [],
			holidayTemplates: [],
			enablePayroll: false
		}
		autobind(this)
	}

	componentDidMount() {
		AccountStore.on("account_change", this.accountChangeEvent)
		this.accountChangeEvent()
	}

	componentWillUnmount() {
		AccountStore.removeListener("account_change", this.accountChangeEvent)
	}

	accountChangeEvent() {
		if (!AccountStore.getCurrentAccount()) return
		this.setState({
			payTypes: AccountStore.getCurrentAccount().PayTypes ? AccountStore.getCurrentAccount().PayTypes : [],
			payGroups: AccountStore.getCurrentAccount().PayGroups ? AccountStore.getCurrentAccount().PayGroups : [],
			otPolicies: AccountStore.getCurrentAccount().OTPolicies ? AccountStore.getCurrentAccount().OTPolicies.filter(i => !i.Deleted) : [],
			accruals: AccountStore.getCurrentAccount().Accruals ? AccountStore.getCurrentAccount().Accruals : [],
			holidayTemplates: AccountStore.getCurrentAccount().HolidayTemplates ? AccountStore.getCurrentAccount().HolidayTemplates : [],
			enablePayroll: AccountStore.getCurrentAccountSettings().FeatureSettings.EnablePayrollWorkflow
		})
	}

	addPayType(payType, cb) {
		accountActions.addPayType(AuthenticationStore.getCookieAccountId(), payType, cb)
	}

	updatePayType(payType, cb) {
		accountActions.updatePayType(AuthenticationStore.getCookieAccountId(), payType, cb)
	}

	deletePayType(payTypeId, cb) {
		accountActions.deletePayType(AuthenticationStore.getCookieAccountId(), payTypeId, cb)
	}

	addPayGroup(payGroup, cb) {
		accountActions.addPayGroup(AuthenticationStore.getCookieAccountId(), payGroup, cb)
	}

	updatePayGroup(payGroup, cb) {
		accountActions.updatePayGroup(AuthenticationStore.getCookieAccountId(), payGroup, cb)
	}

	deletePayGroup(payGroupId, cb) {
		accountActions.deletePayGroup(AuthenticationStore.getCookieAccountId(), payGroupId, cb)
	}

	addAccrual(accrual, cb) {
		accountActions.addAccrual(AuthenticationStore.getCookieAccountId(), accrual, cb)
	}

	updateAccrual(accrual, cb) {
		accountActions.updateAccrual(AuthenticationStore.getCookieAccountId(), accrual, cb)
	}

	deleteAccrual(accrualId, cb) {
		accountActions.deleteAccrual(AuthenticationStore.getCookieAccountId(), accrualId, cb)
	}

	addHolidayTemplate(holidayTemplate, cb) {
		accountActions.addHolidayTemplate(AuthenticationStore.getCookieAccountId(), holidayTemplate, cb)
	}

	updateHolidayTemplate(holidayTemplate, cb) {
		accountActions.updateHolidayTemplate(AuthenticationStore.getCookieAccountId(), holidayTemplate, cb)
	}

	deleteHolidayTemplate(holidayTemplateId, cb) {
		accountActions.deleteHolidayTemplate(AuthenticationStore.getCookieAccountId(), holidayTemplateId, cb)
	}

	render() {
		return (
			<div style={{ margin: -16, height: 400 }}>
				<Tabs>
					<Tab data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupsTab"} label={strings.Pay_Groups.toUpperCase()}>
						<PayGroups
							payGroups={this.state.payGroups}
							payTypes={this.state.payTypes}
							otPolicies={this.state.otPolicies}
							addPayGroup={this.addPayGroup}
							updatePayGroup={this.updatePayGroup}
							deletePayGroup={this.deletePayGroup}
							accountId={AuthenticationStore.getCookieAccountId()}
							enablePayroll={this.state.enablePayroll}
						/>
					</Tab>
					<Tab data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab"} label={strings.Pay_Types.toUpperCase()}>
						<PayTypes
							payTypes={this.state.payTypes}
							addPayType={this.addPayType}
							updatePayType={this.updatePayType}
							deletePayType={this.deletePayType}
							accountId={AuthenticationStore.getCookieAccountId()}
						/>
					</Tab>
					{AccountStore.getEnableOTPolicy() &&
						<Tab data-intercom-target={"menu-AccountSettings-PayConfiguration-OTPoliciesTab"} label={strings.OT_Policies.toUpperCase()}>
							<OTPolicies
								otPolicies={this.state.otPolicies}
								addOTPolicy={(otPolicy, cb) => accountActions.addOTPolicy(AccountStore.getCurrentAccount().Id, otPolicy, cb)}
								updateOTPolicy={(otPolicy, cb) => accountActions.updateOTPolicy(AccountStore.getCurrentAccount().Id, otPolicy, cb)}
								deleteOTPolicy={(deleteOTPolicyId, cb) => accountActions.deleteOTPolicy(AccountStore.getCurrentAccount().Id, deleteOTPolicyId, cb)}
							/>
						</Tab>
					}
					{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
						permissionHelper.hasPermission(AuthenticationStore.Permissions.Accrual.ViewAccrual) &&
						<Tab data-intercom-target={"menu-AccountSettings-PayConfiguration-AccrualsTab"} label={strings.Accruals.toUpperCase()}>
							<Accruals
								accruals={this.state.accruals}
								addAccrual={this.addAccrual}
								updateAccrual={this.updateAccrual}
								deleteAccrual={this.deleteAccrual}
							/>
						</Tab>
					}
					{AccountStore.getCurrentAccountSettings().FeatureSettings.EnableAccrualsTimeoff &&
						<Tab data-intercom-target={"menu-AccountSettings-PayConfiguration-HolidayTemplatesTab"} label={strings.Holiday_Templates.toUpperCase()}>
							<HolidayTemplates
								holidayTemplates={this.state.holidayTemplates}
								addHolidayTemplate={this.addHolidayTemplate}
								updateHolidayTemplate={this.updateHolidayTemplate}
								deleteHolidayTemplate={this.deleteHolidayTemplate}
							/>
						</Tab>
					}
				</Tabs>
			</div>
		)
	}
}